import React from "react";
import header_logo from "../image/logo.png";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();

  return (
    <>
      <div
        className="nav d-flex justify-content-around"
        style={{ backgroundColor: "#262f3a" }}
      >
        <div>
          <img
            src={header_logo}
            height="50"
            alt="IMAG"
            onClick={() => {
              navigate("/");
            }}
          ></img>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="nav_item"
            onClick={() => {
              navigate("/");
            }}
          >
            GAMES
          </div>
          <div
            className="ml-3 nav_item"
            onClick={() => {
              navigate("/termsCondition");
            }}
          >
            TERMS OF USE
          </div>
          <div
            className="ml-3 nav_item"
            onClick={() => {
              navigate("/privacyPolicy");
            }}
          >
            PRIVACY POLICY
          </div>
        </div>
      </div>
    </>
  );
}
